(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-advertorial"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var stickyEls = document.querySelectorAll('[id^="cbStickyCta-"]');
    if (!stickyEls.length) return;

    function handleStickyVisibility() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var isMobile = window.innerWidth <= 768;
      for (var i = 0; i < stickyEls.length; i++) {
        stickyEls[i].style.display = (isMobile && scrollTop > 400) ? 'block' : 'none';
      }
      var advEl = document.querySelector('.cb-adv');
      if (advEl) {
        advEl.style.paddingBottom = isMobile ? '80px' : '0';
      }
    }

    window.addEventListener('scroll', handleStickyVisibility);
    window.addEventListener('resize', handleStickyVisibility);
    handleStickyVisibility();
  })();

  } catch(e) { console.error(e); }
})();
})();
